<template>
    <div class="container">
        <p class="h3">Reset password</p>
            <div class="form-group">
                <input class="form-control"

                       id="email"
                       name="email"
                       type="email"
                       required
                       email
                       placeholder="Enter your E-mail address"
                >
            </div>
            <div class="form-group">
                <input class="form-control"
                       id="newPassword"
                       name="newPassword"
                       type="password"
                       required
                       password
                       placeholder="Enter your new password"
                >
            </div>

            <div class="row justify-content-center">
                <button  type="submit" class="btn btn-primary" >Reset password</button>
                <button type="submit" class="orange-button" >Set new password</button>
            </div>


        <div class="option">
            <div class="row justify-content-center mb-small">
                <span class="font-medium">Don't have an account? </span>
                <a class="normal" > Sign up now</a>
            </div>

            <div class="row justify-content-center">
                <span class="font-medium">Already have an account? </span>
                <a class="normal" > Login here</a>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: "ResetPage"
    }
</script>

<style scoped>

    .container {
        max-width: 500px;
        margin: auto;
    }
    .h3{
        color:#444444;
        font-size:40px;
        margin:0 0 35px 0;
    }

    .form-group {
        margin-bottom:25px;
    }
    .option {
        margin-top: 60px;
    }
    .form-control {
        background: #f7f7f7 none repeat scroll 0 0;
        border: 1px solid #d4d4d4;
        border-radius: 4px;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
    }
    .btn {
        height: 50px;
    }

</style>
